import { getMedia } from "@/constants/constants";
import { ApiHit } from "@/constants/utils";
import { useState, useEffect } from "react";

const useFetchData = (categoryType) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!categoryType) return; // Prevent API call if categoryType is empty

        const fetchData = async () => {
            try {
                setLoading(true);
                const json = {
                    page: 1,
                    limit: 100,
                    search: { category: categoryType }
                };



                const response = await ApiHit(json, getMedia);



                if (response?.status === 200) {
                    response?.doc.docs?.map((ele, index) => Object.assign(ele, { url: ele.downloadLink }))
                    setData(response?.doc.docs.reverse());
                } else {
                    setError("Failed to fetch data");
                }
            } catch (err) {
                setError(err.message || "An error occurred");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [categoryType]); // Fetch data when categoryType changes

    return { data, loading, error };
};

export default useFetchData;
